import { Authorization } from "@app/core/shared/data/network/base-handler.parameters";

/**
 * Authorization using a token.
 * Used to send the authorization header in the BaseHandler.
 */
export class TokenAuthorization implements Authorization {
  constructor(private token: string) {}

  getBasicAuthorization(): string {
    return `Token ${this.token}`;
  }
}
